import type { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import type { Vue } from 'vue/types/vue';
import type { ObjectFormComponent } from '@/mixins/objectForm';

import objectForm from '@/mixins/objectForm';

import User from '@/models/User';

const userForm: ThisTypedComponentOptionsWithRecordProps<
  UserFormComponent,
  {},
  UserFormMixinMethods,
  UserFormMixinComputed,
  UserFormMixinProps
> = {
  extends: objectForm(User) as any,
  props: {
    liveChanges: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelSource() {
      return this.$activeUser;
    },
    profile() {
      return this.user.profile;
    },
    user() {
      return this.model || (this.model = this.convertModel(this.modelSource));
    },
  },
  methods: {
    convertModel(data) {
      return this.liveChanges ? User.from(data) : new User(data);
    },
  },
  async created() {
    if (!this.inputModel && this.$isLoggedIn) {
      await this.$store.dispatch('users/getActiveUser');
    }
  },
};

export default userForm as ThisTypedComponentOptionsWithRecordProps<
  Vue,
  {},
  UserFormMixinMethods,
  UserFormMixinComputed,
  UserFormMixinProps
>;

export interface UserFormComponent extends ObjectFormComponent<globalThis.User> {
  /**
   * __(Prop)__
   *
   * If `true`, then changes within the form are applied to the original user object in-place.
   * Otherwise, changes are applied to a copy of the user object.
   *
   * @default false
   */
  readonly liveChanges: boolean;

  /**
   * __(Computed)__
   *
   * The `Profile` object associated with the `user`.
   */
  readonly profile: globalThis.Profile;
  /**
   * __(Computed)__
   *
   * The user being edited.
   */
  readonly user: globalThis.User;
}

export type UserFormMixinComputed = Pick<UserFormComponent, 'modelSource' | 'profile' | 'user'>;

export type UserFormMixinMethods = Pick<UserFormComponent, 'convertModel'>;

export type UserFormMixinProps = Pick<UserFormComponent, 'liveChanges'>;
